import {createSelector} from "reselect";

const sites = (state) => state.sites;

export const getSitesData = createSelector(sites, (sites) => sites.sitesData || {});

export const getSiteList = createSelector(getSitesData, (data) => data.results || []);

export const getSitesNextUrl = createSelector(getSitesData, (data) => data.next);

export const getCurrentSite = createSelector(sites, (sites) => sites.currentSite || {});

export const getLocations = createSelector(sites, (sites) => sites.locations);
export const getLocationsList = createSelector(getLocations, (locations) =>
  locations.map((location) => ({
    label: location.name,
    value: location.id,
  }))
);

export const getSelectedLocations = createSelector(
  sites,
  (sites) => sites.selectedLocation || {}
);

export const getAddressData = createSelector(sites, (sites) => sites.addressList);
